var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrees(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39,
    height: 36,
    viewBox: "0 0 39 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51754 1.18652C13.0238 1.18652 16.6768 4.83943 16.6768 9.34571C16.6768 13.852 13.0238 17.5049 8.51754 17.5049C4.01126 17.5049 0.358398 13.852 0.358398 9.34571C0.358398 4.83943 4.01126 1.18652 8.51754 1.18652Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51714 4.24707H9.19883C12.7685 4.24707 15.6565 7.14025 15.6565 10.7047C15.6565 14.2743 12.7633 17.1623 9.19883 17.1623H8.51714C4.9475 17.1623 2.05957 14.2691 2.05957 10.7047C2.05957 7.13504 4.9527 4.24707 8.51714 4.24707Z",
    fill: "#62AE80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17285 10.3633V35.5173",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9341 11.0479L8.17285 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75488 11.0479L8.51608 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3906 1.18652C23.8969 1.18652 27.5497 4.83943 27.5497 9.34571C27.5497 13.852 23.8969 17.5049 19.3906 17.5049C14.8843 17.5049 11.2314 13.852 11.2314 9.34571C11.2314 4.83943 14.8843 1.18652 19.3906 1.18652Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3932 4.24707H20.0749C23.6446 4.24707 26.5325 7.14025 26.5325 10.7047C26.5325 14.2743 23.6394 17.1623 20.0749 17.1623H19.3932C15.8236 17.1623 12.9355 14.2691 12.9355 10.7047C12.9355 7.13504 15.8288 4.24707 19.3932 4.24707Z",
    fill: "#62AE80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 10.3633V35.5173",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.816 11.0479L19.0547 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6348 11.0479L19.3961 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2724 1.18652C34.7787 1.18652 38.4316 4.83943 38.4316 9.34571C38.4316 13.852 34.7787 17.5049 30.2724 17.5049C25.7661 17.5049 22.1133 13.852 22.1133 9.34571C22.1133 4.83943 25.7661 1.18652 30.2724 1.18652Z",
    fill: "#AACAC9",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.272 4.24707H30.9537C34.5234 4.24707 37.4113 7.14025 37.4113 10.7047C37.4113 14.2743 34.5182 17.1623 30.9537 17.1623H30.272C26.7024 17.1623 23.8145 14.2691 23.8145 10.7047C23.8145 7.13504 26.7076 4.24707 30.272 4.24707Z",
    fill: "#62AE80"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6889 11.0479L29.9277 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5107 11.0479L30.2719 15.8091",
    stroke: "#382456",
    strokeWidth: 0.520356
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9277 10.3633V35.5173",
    stroke: "#382456",
    strokeWidth: 0.520356
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/Trees.87531df0249780dc9e60.svg";
export { ForwardRef as ReactComponent };